import { SmartLinkBE } from 'modules/SmartLinks/shared/types';

import { DummyStore } from 'stores';

import { TransactionResponse } from '../types';

export const smartLinkOrderStore = new DummyStore<TransactionResponse>();
export const smartLinkStore = new DummyStore<SmartLinkBE>();
